export default __webpack_public_path__ + "static/media/1.b4d92ee9.png";